import React from 'react';
import { Container } from 'react-bootstrap';
import { FaRegCopyright, FaHeart, FaRocket } from 'react-icons/fa';

const Footer = () => {
  const year = 2025; // Futuristic year for our 2025design
  
  return (
    <footer className="footer-2025py-4 mt-5">
      <Container className="text-center">
        <div className="footer-content">
          <div className="footer-icon">
            <FaRocket />
          </div>
          <p className="mb-0 footer-text">
            <FaRegCopyright className="me-1" /><span className="highlight-text">JVX's very own SRM - Client Management System </span>  
          </p>
          <p className="mt-2 small footer-tagline">
            Built with <FaHeart className="text-danger mx-1" /> for the future
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
